import { Button, LinearProgress } from "@material-ui/core";

import TableNew, { CELL_TYPES } from "../../../shared/Table";
import TableActionRemoveFromFile from "./TableActionRemoveFromFile";

function get_columns(file) {
  const cfg = [
    { key: "LoanId", label: "LoanId", visible: true, type: CELL_TYPES.text },
    {
      key: "CapitalAmount.Amount",
      label: "Capital Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "UnpaidInterest.Amount",
      label: "Unpaid Interest",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "UnpaidFees.Amount",
      label: "Unpaid Fees",
      visible: true,
      type: CELL_TYPES.money,
    },
  ];

  if (!file.Finalized) {
    cfg.push({
      key: "Id",
      label: "Actions",
      visible: true,
      filter: false,
      type: CELL_TYPES.custom,
      renderer: (value, item, props) => {
        return (
          <TableActionRemoveFromFile {...props} value={value} item={item} />
        );
      },
    });
  }
  return cfg;
}

const _FileDetails = ({ file, loadDetails, removeLoanFromFile }) => {
  if (!file.details)
    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={() => loadDetails(file.Id)}
      >
        Load Details
      </Button>
    );
  if (file.details.fetched) {
    return (
      <TableNew
        columns={get_columns(file)}
        items={file.details.data.Loans}
        tableKey={"file-export-" + file.Id}
        fileId={file.Id}
        actionColumnWidth={350}
        removeLoanFromFile={removeLoanFromFile}
      />
    );
  }

  if (file.details.fetching) return <LinearProgress />;
};

export default _FileDetails;
